import React__default from 'react';
import { useApiClient, Products } from '@grandvisionhq/api-client';
import { useApiConfig } from '@grandvisionhq/state';

const useFetchBundle = (bundleSku)=>{
    const { productsUrl  } = useApiConfig();
    const params = React__default.useMemo(()=>bundleSku ? {
            sku: bundleSku
        } : null
    , [
        bundleSku
    ]);
    const bundleRequestOptions = React__default.useMemo(()=>({
            skip: !params
        })
    , [
        params
    ]);
    const [, data] = useApiClient(Products.getContactLensBundles, bundleRequestOptions, productsUrl, params);
    return data;
};

export { useFetchBundle };
//# sourceMappingURL=use-fetch-bundle.js.map
